/**
 * WIECEL CRO LAYER - kleine Helfer fuer Kollektions- und Produktseiten.
 * Wird in layout/theme.liquid mit "defer" geladen.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function headerOffset() {
    var header = document.querySelector('.shopify-section--header, [id$="__header"]');
    return header ? header.offsetHeight + 12 : 12;
  }

  ready(function () {
    /* 1. Kollektionsbeschreibung: zwei Zeilen + "Mehr lesen" */
    var descList = [];
    var bannerDesc = document.querySelector('[id$="__collection-banner"] .page-header__text-wrapper > div');
    if (bannerDesc) descList.push(bannerDesc);
    if (document.body.classList.contains('wiecel-tpl-collection')) {
      var richDesc = document.querySelector('.shopify-section--rich-text .text-container > p + p');
      if (richDesc) descList.push(richDesc);
    }
    descList.forEach(function (desc) {
      if (desc.textContent.trim().length <= 140) return;
      desc.classList.add('wiecel-clamp');
      requestAnimationFrame(function () {
        if (desc.scrollHeight <= desc.clientHeight + 4) return;
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'wiecel-clamp-toggle';
        toggle.textContent = 'Mehr lesen';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', function () {
          var open = desc.classList.toggle('is-open');
          toggle.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        desc.parentNode.appendChild(toggle);
      });
    });

    /* 2. Produktseite: Link "Groessentabelle" springt zur Tabelle in der Beschreibung */
    var content = document.querySelector('.shopify-section--product-content');
    if (content && content.querySelector('img')) {
      document.documentElement.classList.add('wiecel-has-size-chart');
    }
  });

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-wiecel-size-chart]') : null;
    if (!link) return;
    var img = document.querySelector('.product-tabs__tab-item-content img, .product__description img, .shopify-section--product-content img'); if (!img) return; event.preventDefault(); setTimeout(function () { var col = img.closest('collapsible-content'), wait = 50; if (col && !col.hasAttribute('open')) { var tg = document.querySelector('[aria-controls=' + CSS.escape(col.id) + ']'); if (tg) { tg.click(); wait = 450; } } setTimeout(function () { window.scrollTo({ top: img.getBoundingClientRect().top + window.pageYOffset - headerOffset(), behavior: 'smooth' }); }, wait); }, 250);
  });
})();
